"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorldCharacter = void 0;
const definables_1 = require("definables");
const retrommo_types_1 = require("retrommo-types");
const Figure_1 = require("./Figure");
const Item_1 = require("./Item");
const Player_1 = require("./Player");
const SkinColor_1 = require("./SkinColor");
const pixel_pigeon_1 = require("pixel-pigeon");
class WorldCharacter extends definables_1.Definable {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        super(options.id);
        this._emote = null;
        this._entityID = null;
        this._markerEntityID = null;
        this._movedAt = null;
        this._questInstances = {};
        this._step = retrommo_types_1.Step.Right;
        this._wasClicked = false;
        this._clothesDyeItemID = (_a = options.clothesDyeItemID) !== null && _a !== void 0 ? _a : null;
        this._direction = options.direction;
        this._figureID = options.figureID;
        this._hairDyeItemID = (_b = options.hairDyeItemID) !== null && _b !== void 0 ? _b : null;
        this._isRenewing = (_c = options.isRenewing) !== null && _c !== void 0 ? _c : null;
        this._maskItemID = (_d = options.maskItemID) !== null && _d !== void 0 ? _d : null;
        this._openedChestIDs = (_e = options.openedChestIDs) !== null && _e !== void 0 ? _e : null;
        this._order = options.order;
        this._outfitItemID = (_f = options.outfitItemID) !== null && _f !== void 0 ? _f : null;
        this._playerID = options.playerID;
        this._position = {
            x: options.position.x,
            y: options.position.y,
        };
        for (const questID in options.questInstances) {
            const questInstance = options.questInstances[questID];
            if (typeof questInstance === "undefined") {
                throw new Error("No quest instance.");
            }
            this._questInstances[questID] = {
                isCompleted: questInstance.isCompleted,
                isStarted: questInstance.isStarted,
                monsterKills: questInstance.monsterKills,
            };
        }
        this._resources =
            typeof options.resources !== "undefined"
                ? {
                    hp: options.resources.hp,
                    maxHP: options.resources.maxHP,
                    maxMP: (_g = options.resources.maxMP) !== null && _g !== void 0 ? _g : null,
                    mp: (_h = options.resources.mp) !== null && _h !== void 0 ? _h : null,
                }
                : null;
        this._skinColorID = options.skinColorID;
        this._step = options.step;
        this._tilemapID = options.tilemapID;
    }
    get clothesDyeItem() {
        if (this._clothesDyeItemID !== null) {
            return (0, definables_1.getDefinable)(Item_1.Item, this._clothesDyeItemID);
        }
        throw new Error(this.getAccessorErrorMessage("clothesDyeItem"));
    }
    get clothesDyeItemID() {
        if (this._clothesDyeItemID !== null) {
            return this._clothesDyeItemID;
        }
        throw new Error(this.getAccessorErrorMessage("clothesDyeItemID"));
    }
    get direction() {
        return this._direction;
    }
    get emote() {
        if (this._emote !== null) {
            return this._emote;
        }
        throw new Error(this.getAccessorErrorMessage("emote"));
    }
    get entityID() {
        if (this._entityID !== null) {
            return this._entityID;
        }
        throw new Error(this.getAccessorErrorMessage("entityID"));
    }
    get figure() {
        return (0, definables_1.getDefinable)(Figure_1.Figure, this._figureID);
    }
    get figureID() {
        return this._figureID;
    }
    get hairDyeItem() {
        if (this._hairDyeItemID !== null) {
            return (0, definables_1.getDefinable)(Item_1.Item, this._hairDyeItemID);
        }
        throw new Error(this.getAccessorErrorMessage("hairDyeItem"));
    }
    get hairDyeItemID() {
        if (this._hairDyeItemID !== null) {
            return this._hairDyeItemID;
        }
        throw new Error(this.getAccessorErrorMessage("hairDyeItemID"));
    }
    get isRenewing() {
        if (this._isRenewing !== null) {
            return this._isRenewing;
        }
        throw new Error(this.getAccessorErrorMessage("isRenewing"));
    }
    get markerEntityID() {
        if (this._markerEntityID !== null) {
            return this._markerEntityID;
        }
        throw new Error(this.getAccessorErrorMessage("markerEntityID"));
    }
    get maskItem() {
        if (this._maskItemID !== null) {
            return (0, definables_1.getDefinable)(Item_1.Item, this._maskItemID);
        }
        throw new Error(this.getAccessorErrorMessage("maskItem"));
    }
    get maskItemID() {
        if (this._maskItemID !== null) {
            return this._maskItemID;
        }
        throw new Error(this.getAccessorErrorMessage("maskItemID"));
    }
    get movedAt() {
        if (this._movedAt !== null) {
            return this._movedAt;
        }
        throw new Error(this.getAccessorErrorMessage("movedAt"));
    }
    get openedChestIDs() {
        if (this._openedChestIDs !== null) {
            return this._openedChestIDs;
        }
        throw new Error(this.getAccessorErrorMessage("openedChestIDs"));
    }
    get order() {
        return this._order;
    }
    get outfitItem() {
        if (this._outfitItemID !== null) {
            return (0, definables_1.getDefinable)(Item_1.Item, this._outfitItemID);
        }
        throw new Error(this.getAccessorErrorMessage("outfitItem"));
    }
    get outfitItemID() {
        if (this._outfitItemID !== null) {
            return this._outfitItemID;
        }
        throw new Error(this.getAccessorErrorMessage("outfitItemID"));
    }
    get playerID() {
        return this._playerID;
    }
    get position() {
        return this._position;
    }
    get questInstances() {
        return this._questInstances;
    }
    get player() {
        return (0, definables_1.getDefinable)(Player_1.Player, this._playerID);
    }
    get resources() {
        if (this._resources !== null) {
            return this._resources;
        }
        throw new Error(this.getAccessorErrorMessage("resources"));
    }
    get skinColor() {
        return (0, definables_1.getDefinable)(SkinColor_1.SkinColor, this._skinColorID);
    }
    get skinColorID() {
        return this._skinColorID;
    }
    get step() {
        return this._step;
    }
    get tilemapID() {
        return this._tilemapID;
    }
    get wasClicked() {
        return this._wasClicked;
    }
    set clothesDyeItemID(clothesDyeItemID) {
        this._clothesDyeItemID = clothesDyeItemID;
    }
    set direction(direction) {
        this._direction = direction;
    }
    set emote(emote) {
        this._emote = emote;
    }
    set entityID(entityID) {
        this._entityID = entityID;
    }
    set hairDyeItemID(hairDyeItemID) {
        this._hairDyeItemID = hairDyeItemID;
    }
    set isRenewing(isRenewing) {
        this._isRenewing = isRenewing;
    }
    set markerEntityID(markerEntityID) {
        this._markerEntityID = markerEntityID;
    }
    set maskItemID(maskItemID) {
        this._maskItemID = maskItemID;
    }
    set movedAt(movedAt) {
        this._movedAt = movedAt;
    }
    set openedChestIDs(openedChestIDs) {
        this._openedChestIDs = openedChestIDs;
    }
    set order(order) {
        this._order = order;
    }
    set outfitItemID(outfitItemID) {
        this._outfitItemID = outfitItemID;
    }
    set position(position) {
        this._position = position;
    }
    set questInstances(questInstances) {
        this._questInstances = questInstances;
    }
    set resources(resources) {
        this._resources = resources;
    }
    set step(step) {
        this._step = step;
    }
    set tilemapID(tilemapID) {
        this._tilemapID = tilemapID;
    }
    set wasClicked(wasClicked) {
        this._wasClicked = wasClicked;
    }
    hasClothesDyeItem() {
        return this._clothesDyeItemID !== null;
    }
    hasEmote() {
        return this._emote !== null;
    }
    hasHairDyeItem() {
        return this._hairDyeItemID !== null;
    }
    hasIsRenewing() {
        return this._isRenewing !== null;
    }
    hasMarkerEntity() {
        return this._markerEntityID !== null;
    }
    hasMaskItem() {
        return this._maskItemID !== null;
    }
    hasMovedAt() {
        return this._movedAt !== null;
    }
    hasOutfitItem() {
        return this._outfitItemID !== null;
    }
    remove() {
        if (this._entityID !== null) {
            (0, pixel_pigeon_1.removeEntity)(this._entityID);
        }
        if (this._emote !== null) {
            (0, pixel_pigeon_1.removeEntity)(this._emote.entityID);
        }
        if (this._markerEntityID !== null) {
            (0, pixel_pigeon_1.removeEntity)(this._markerEntityID);
        }
        if (this._playerID !== null) {
            this.player.worldCharacterID = null;
        }
        super.remove();
    }
}
exports.WorldCharacter = WorldCharacter;
